import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18n from '../../../i18n';
import Analytics from '../../../utils/analytics';
import RequestApprovalPopupLayout from './RequestApprovalPopupLayout';
import Conversation from '../../../models/Conversation';
import User from '../../../models/User';
import history from '../../../history';
import Utils from '../../../utils/utils';

const ModificationReceiverRejectPopup = ({
    show,
    closeReceiverRejectModal,
    rejectModificationRequest,
    conversation,
    user
}) => {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const closeModal = useCallback(() => {
        setIsLoading(false);
        closeReceiverRejectModal();
    }, [closeReceiverRejectModal]);

    const reject = useCallback(() => {
        setIsLoading(true);
        rejectModificationRequest().then(
            () => {
                Analytics.trackGTM(
                    'exchange_status',
                    {
                        event_data: {
                            exchange_status: 'finalized',
                            modification_status: 'declined',
                            exchange_type: conversation.isMutual()
                                ? 'reciprocal_exchange'
                                : 'guest_point_exchange',
                            collection: user.isCollection()
                        }
                    },
                    () => {
                        setIsLoading(false);
                        closeModal();
                        history.push(`${Utils.getUrlLocalePrefix()}/conversations/${conversation.get('id')}`);
                        window.location.reload();
                    }
                );
            },
            (error) => {
                setIsLoading(false);
                closeModal();
                console.error(`[ERROR: REJECT MODIFICATION REQUEST]: ${error}`);
            }
        );
    }, [rejectModificationRequest]);

    useEffect(() => {
        setShowModal(show);
    }, [show]);

    return (
        <RequestApprovalPopupLayout show={showModal}>
            <div className="block-content">
                <div className="content-title">{i18n.t('messaging:are_you_sure')}</div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: i18n.t('messaging:receiver_rejects_modification_warning_modale')
                    }}
                ></div>
            </div>
            <div className="block-cta">
                <button
                    className={classNames('hends-primary confirm btn-ajax', {
                        sending: isLoading
                    })}
                    id="reject-request-confirm"
                    onClick={reject}
                >
                    {i18n.t('messaging:receiver_rejects_modification_CTA_confirm_warning_modale')}
                </button>
                <button className="hends-secondary cancel" id="reject-request-cancel" onClick={closeModal}>
                    {i18n.t('exchange:cancel')}
                </button>
            </div>
        </RequestApprovalPopupLayout>
    );
};

ModificationReceiverRejectPopup.propTypes = {
    show: PropTypes.bool.isRequired,
    closeReceiverRejectModal: PropTypes.func.isRequired,
    rejectModificationRequest: PropTypes.func.isRequired,
    conversation: PropTypes.instanceOf(Conversation),
    user: PropTypes.instanceOf(User)
};

export default ModificationReceiverRejectPopup;
